// extracted by mini-css-extract-plugin
module.exports = {"progress-section":"styles_progress-section__30FVw","selected":"styles_selected__w5o8i"};